import React from 'react';
import { withRouter } from 'react-router-dom';
import OverseaCardForm from './OverseaCardForm';


class OverseaCardEdit extends React.Component {
    constructor(props){
        super(props);
        this.id = props.match.params.id;
    }
    validateFields = (values,config)=>{
        this.form && this.form.validateFields(values,config);
    }

    render(){
        return (
            <div>
                <OverseaCardForm id={this.id}/>
            </div>
        );
    }

}
export default withRouter(OverseaCardEdit);



// WEBPACK FOOTER //
// ./src/pages/OverseaCard/OverseaCardEdit.js